import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import {
  FDContentContainer,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import DeleteButton from './DeleteButton';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = React.useState(false);

  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
  };

  async function handleSubmit() {
    try {
      setLoading(true);
      await resource.submit();
      clearModalCollection();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  }

  return (
    <FDContentContainer maxWidth="md">
      <PageContentTop
        resource={resource}
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />

      <br />

      <FDStack direction="column" spacing={3}>
        <MetaLayoutVertical resource={resource} />

        {resource.meta().canDelete() ? (
          <DeleteButton
            onDelete={handleDelete}
            onDeleteSuccess={onDeleteSuccess}
            dialogProps={{
              title: 'Are you sure?',
              message: 'Removing this item will delete all of its information. This cannot be undone.',
              confirmLabel: 'Remove',
            }}
          />
        ) : null}
      </FDStack>

      <br />

      <FDStack direction="row" justifyContent="center">
        <FDPrimaryActionButton
          size="lg"
          label="Submit"
          onClick={handleSubmit}
          loading={loading}
        />
      </FDStack>
    </FDContentContainer>
  );
};

export default Layout;
